import { Card, Row, Col, Typography } from "antd";

import AnalyticsGenericBarGraph from "../../../common-utils/GenericBarGraph";

const { Title, Text } = Typography;

const SalesAnalysisGraphs = ({
  dailyPaymentAmountGraphPoints,
  dailyPaymentCountGraphPoints,
  hourlyPaymentCountGraphPoints,
  weekdayPaymentCountGraphPoints
}) => {
  return (
    <>
      <Title level={3}>Sales Graphs</Title>
      <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
        <Col xs={24} lg={12}>
          <Card>
            <Title level={4}>Daily Revenue</Title>
            <Text type="secondary" style={{ display: "block", marginBottom: "16px" }}>
              Shows revenue collected each day in the selected period
            </Text>
            <div style={{ height: "300px" }}>
              <AnalyticsGenericBarGraph
                dataPoints={dailyPaymentAmountGraphPoints}
                xAxisFieldName="date"
                yAxisFieldName="amount"
              />
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card>
            <Title level={4}>Daily Payment Count</Title>
            <Text type="secondary" style={{ display: "block", marginBottom: "16px" }}>
              Shows number of payments processed each day
            </Text>
            <div style={{ height: "300px" }}>
              <AnalyticsGenericBarGraph
                dataPoints={dailyPaymentCountGraphPoints}
                xAxisFieldName="date"
                yAxisFieldName="count"
              />
            </div>
          </Card>
        </Col>

        <Col xs={24}>
          <Card>
            <Title level={4}>Hourly Payment Distribution</Title>
            <Text type="secondary" style={{ display: "block", marginBottom: "16px" }}>
              Shows payment frequency by hour of day across all selected dates
            </Text>
            <div style={{ height: "300px" }}>
              <AnalyticsGenericBarGraph
                dataPoints={hourlyPaymentCountGraphPoints}
                xAxisFieldName="hour"
                yAxisFieldName="count"
              />
            </div>
          </Card>
        </Col>

        <Col xs={24}>
          <Card>
            <Title level={4}>Week Day Payment Distribution</Title>
            <Text type="secondary" style={{ display: "block", marginBottom: "16px" }}>
              Shows payment frequency by day of week across all selected dates
            </Text>
            <div style={{ height: "300px" }}>
              <AnalyticsGenericBarGraph
                dataPoints={weekdayPaymentCountGraphPoints}
                xAxisFieldName="day"
                yAxisFieldName="count"
              />
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default SalesAnalysisGraphs;
